import { generateAltText, optimizePexelsUrl } from '../../lib/utils/imageOptimization';

interface ReservationsHeroProps {
  t: any; // Translations object
}

const ReservationsHero = ({ t }: ReservationsHeroProps) => {
  return (
    <div className="relative h-80 md:h-96 flex items-center">
      <div className="absolute inset-0 z-0">
        <div
          className="absolute inset-0 bg-cover bg-center"
          style={{
            backgroundImage: `url("${optimizePexelsUrl('https://images.pexels.com/photos/262047/pexels-photo-262047.jpeg', 1920, 1080)}")`,
          }}
          aria-label={generateAltText('interior', 'Book a table at Rossopomodoro Reykjavik')}
        >
          <div className="absolute inset-0 bg-black/50"></div>
        </div>
      </div>
      <div className="container-custom relative z-10 text-center text-white">
        <h1 className="font-serif text-4xl md:text-5xl lg:text-6xl font-bold mb-4">
          {t.reservations.hero.title}
        </h1>
        <p className="text-lg md:text-xl max-w-2xl mx-auto" itemProp="description">
          {t.reservations.hero.subtitle}
        </p>
        <p className="text-base md:text-lg max-w-2xl mx-auto mt-4 text-white/80">
          Reserve your table at the best Italian restaurant in downtown Reykjavik
        </p>
      </div>
    </div>
  );
};

export default ReservationsHero;
